module.exports = __webpack_public_path__ + "static/pc-93e50a6f69e54591af5c980435d0b4a3.svg";